export const ACCENT_MARK_CLASS = 'bg-primary text-primary-foreground';
